import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { TrustBar } from '../components/TrustBar';
import { TestimonialsTop } from '../components/TestimonialsTop';
import { ProblemSection } from '../components/ProblemSection';
import { BikeStorySection } from '../components/BikeStorySection';
import { VisualMethods } from '../components/VisualMethods';
import { FiveVolumes } from '../components/FiveVolumes';
import { ThirtyDayPlan } from '../components/ThirtyDayPlan';
import { BonusesSection } from '../components/BonusesSection';
import { DeliverySection } from '../components/DeliverySection';
import { AcceleratorKit } from '../components/AcceleratorKit';
import { IsThisForYou } from '../components/IsThisForYou';
import { PricingSection } from '../components/PricingSection';
import { WhatsIncluded } from '../components/WhatsIncluded';
import { TestimonialsBottom } from '../components/TestimonialsBottom';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FaqSection } from '../components/FaqSection';
import { CostOfInaction } from '../components/CostOfInaction';
import { FinalPricingCTA } from '../components/FinalPricingCTA';
import { EmotionalClose } from '../components/EmotionalClose';
import { Footer } from '../components/Footer';
import { StickyCTA } from '../components/StickyCTA';
import { SocialProofToast } from '../components/SocialProofToast';
export function Landing() {
  return <main className="min-h-screen bg-slate-50" data-id="element-375">
      <HeroSection data-id="element-376" />
      <TrustBar data-id="element-377" />
      <TestimonialsTop data-id="element-378" />
      <ProblemSection data-id="element-379" />
      <BikeStorySection data-id="element-380" />
      <VisualMethods data-id="element-381" />
      <FiveVolumes data-id="element-382" />
      <ThirtyDayPlan data-id="element-383" />
      <BonusesSection data-id="element-384" />
      <DeliverySection data-id="element-385" />
      <IsThisForYou data-id="element-386" />
      <PricingSection data-id="element-387" />
      <AcceleratorKit data-id="element-388" />
      <WhatsIncluded data-id="element-389" />
      <TestimonialsBottom data-id="element-390" />
      <GuaranteeSection data-id="element-391" />
      <FaqSection data-id="element-392" />
      <CostOfInaction data-id="element-393" />
      <FinalPricingCTA data-id="element-394" />
      <EmotionalClose data-id="element-395" />
      <Footer data-id="element-396" />
      <StickyCTA data-id="element-397" />
      <SocialProofToast data-id="element-398" />
    </main>;
}